import apiPath from "../config/api-path";
import httpRequest from "../config/http-api";

export default {
  userLogin({payload,success,error}){
    const {
      users: { login }
    } = apiPath;
    return httpRequest.postRequest(login, payload, success, error)
  },
  createUser(payload, { success, error }) {
    const {
      users: { create },
    } = apiPath;
    return httpRequest.postRequest(create, payload, success, error);
  },
  getUserList(config, { success, error }) {
    const {
      users: { list },
    } = apiPath;
    return httpRequest.getRequest(list, success, error, config);
  },
  getAssigneeList(config, { success, error }) {
    const {
      users: { assignee },
    } = apiPath;
    return httpRequest.getRequest(assignee, success, error, config);
  },
  updateTaskStatus(data, { success, error }) {
    const {
      workSheet: { updateTask },
    } = apiPath;
    return httpRequest.putRequest(updateTask, data, success, error);
  },
  getHistoryById(id, { success, error }) {
    const {
      users: { getHistory },
    } = apiPath;
    return httpRequest.getRequest(getHistory(id), success, error);
  },
  getAllHistory({ success, error }) {
    const {
      users: { getAllHistory },
    } = apiPath;
    return httpRequest.getRequest(getAllHistory, success, error);
  },
  getAllWorkSheet(id, { success, error }) {
    const {
      workSheet: { getWorkSheetByUserId },
    } = apiPath;
    return httpRequest.getRequest(getWorkSheetByUserId(id), success, error);
  },
  getLocationOption({ success, error }) {
    const {
      users: { locationOption },
    } = apiPath;
    return httpRequest.getRequest(locationOption, success, error);
  },
  getTeamOption({ success, error }) {
    const {
      users: { teamOption },
    } = apiPath;
    return httpRequest.getRequest(teamOption, success, error);
  },
  getDesignationOption(config, { success, error }) {
    const {
      users: { designation },
    } = apiPath;
    return httpRequest.getRequest(designation, success, error, config);
  },
  getManagerOption(config, { success, error }) {
    const {
      users: { manager },
    } = apiPath;
    return httpRequest.getRequest(manager, success, error, config);
  },
  getEmployeeByManagerId(id, config, { success, error }) {
    const {
      users: { getEmployeeByManagerId },
    } = apiPath;
    return httpRequest.getRequest(getEmployeeByManagerId(id), success, error, config);
  },
  updateUserPassword(payload, {success, error}){
    const {
      users: { updatePassword },
    } = apiPath;
    console.log(payload)
    return httpRequest.postRequest(updatePassword, payload, success, error);
  }
};
